import { ICloudpaymentsStartWidgetPaymentResponse } from '../../../../repositories/billing-accounts/v1/cloudpayments/start-widget-payment';
import { ICloudPaymentsWidgetOptions } from '../../../../types/cloudPayments';

export const mapWidgetOptions = (response: ICloudpaymentsStartWidgetPaymentResponse): ICloudPaymentsWidgetOptions => {
  const { sbpSupport } = response;

  return {
    sbpSupport,
  };
};
